export const MAX_DISCOUNT_QTY = 16;
export function isAnnualSponsorship(item) {
    return item?.type === "AnnualSponsorship";
}
export function isSilverSponsorship(item) {
    return item?.type === "SilverSponsorship";
}
export function isGoldSponsorship(item) {
    return item?.type === "GoldSponsorship";
}
export function isPlatinumSponsorship(item) {
    return item?.type === "PlatinumSponsorship";
}
export function isSapphireSponsorship(item) {
    return item?.type === "SapphireSponsorship";
}
export function isEmeraldSponsorship(item) {
    return item?.type === "EmeraldSponsorship";
}
export function isRubySponsorship(item) {
    return item?.type === "RubySponsorship";
}
export function isDiamondSponsorship(item) {
    return item?.type === "DiamondSponsorship";
}
//# sourceMappingURL=annual-sponsorship.js.map